import {
  Flex,
  Heading,
  IconAssignmentLine,
  IconAssignmentSolid,
  IconCloudUploadLine,
  IconCloudUploadSolid,
  IconGradebookLine,
  IconGradebookSolid,
  Text,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { Link, Outlet, useLocation, useOutletContext } from "react-router";
import { Card } from "../../../../components/Card";
import ProgressStepper from "../../../../components/ProgressStepper";
import "./scores.css";
import { ASSIGNMENT, getFinalizeSteps, LMG, UPLOAD } from "./utils";

const FinalizeHome = () => {
  const { setNextEnabled, formData, setFormData, assignments } =
    useOutletContext();
  const { t } = useTranslation();
  const location = useLocation();
  const path = location.pathname;

  function onCardClick(type) {
    setFormData({ type: type, metadata: {} });
    setNextEnabled(false);
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
      }}
    >
      <ProgressStepper steps={getFinalizeSteps(t)} currentStep={1} />
      <div style={{ flex: 1, overflowY: "hidden" }}>
        <Flex gap="small" height="100%">
          <Flex.Item size="30%" height="100%" padding="0 small">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                gap: "0.75rem",
              }}
            >
              <Heading level="h3" as="h2" border="bottom">
                {t("finalizeCourse.methodOfFinalization")}
              </Heading>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "1.5rem",
                  overflowY: "auto",
                  paddingRight: "0.5rem",
                  marginRight: "-0.5rem",
                }}
              >
                <Link
                  to="assignment"
                  state={location.state}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Card
                    onClick={() => {
                      if (path !== "/scores/home/assignment") {
                        onCardClick(ASSIGNMENT);
                      }
                    }}
                    style={{ textAlign: "center" }}
                    className={`cardStyle ${path === "/scores/home/assignment" ? "selectedCard" : ""}`}
                  >
                    {path === "/scores/home/assignment" ? (
                      <IconAssignmentSolid size="large" />
                    ) : (
                      <IconAssignmentLine size="large" />
                    )}
                    <Text weight="bold">
                      {t("finalizeCourse.canvasAssignment")}
                    </Text>
                  </Card>
                </Link>
                <Link
                  to="lmg"
                  state={location.state}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Card
                    onClick={() => {
                      if (path !== "/scores/home/lmg") {
                        onCardClick(LMG);
                      }
                    }}
                    style={{ textAlign: "center" }}
                    className={`cardStyle ${path === "/scores/home/lmg" ? "selectedCard" : ""}`}
                  >
                    {path === "/scores/home/lmg" ? (
                      <IconGradebookSolid size="large" />
                    ) : (
                      <IconGradebookLine size="large" />
                    )}
                    <Text weight="bold">
                      {t("finalizeCourse.learningMasteryGradebook")}
                    </Text>
                  </Card>
                </Link>
                <Link
                  to="upload"
                  state={location.state}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Card
                    onClick={() => {
                      if (path !== "/scores/home/upload") {
                        onCardClick(UPLOAD);
                      }
                    }}
                    style={{ textAlign: "center" }}
                    className={`cardStyle ${path === "/scores/home/upload" ? "selectedCard" : ""}`}
                  >
                    {path === "/scores/home/upload" ? (
                      <IconCloudUploadSolid size="large" />
                    ) : (
                      <IconCloudUploadLine size="large" />
                    )}
                    <Text weight="bold">
                      {t("finalizeCourse.uploadScores")}
                    </Text>
                  </Card>
                </Link>
              </div>
            </div>
          </Flex.Item>
          <Flex.Item height="100%">
            <div style={{ height: "100%", borderRight: "1px solid #ccc" }} />
          </Flex.Item>
          <Flex.Item
            shouldGrow
            shouldShrink
            height="100%"
            overflowY="hidden"
            padding="0 small"
          >
            <Outlet
              context={{ setNextEnabled, formData, setFormData, assignments }}
            />
          </Flex.Item>
        </Flex>
      </div>
    </div>
  );
};

export default FinalizeHome;
